import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Realisations from "@/pages/Realisations";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";
import CGV from "@/pages/CGV";
import CGU from "@/pages/CGU";
import Confidentialite from "@/pages/Confidentialite";
import Merci from "@/pages/Merci";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/a-propos" element={<APropos />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/conditions-generales-de-vente" element={<CGV />} />
          <Route path="/conditions-generales-utilisation" element={<CGU />} />
          <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
          <Route path="/merci" element={<Merci />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
